import { render, staticRenderFns } from "./OtherButton.vue?vue&type=template&id=adf1a654&"
import script from "./OtherButton.vue?vue&type=script&lang=js&"
export * from "./OtherButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports